import AGSControlList from "ags/controls/ags-control-list";

import AGSBetBarComponent from "ags/components/ags-bet-bar-component";
import authRecordBuilder from "ags/integration/builders/records/auth-record-builder";
import RecoveryRecordBuilder from "ags/integration/builders/records/recovery-record-builder";
import spinRecordBuilder from "ags/integration/builders/records/spin-record-builder";
import authRequestBuilder from "ags/integration/builders/requests/auth-request-builder";
import freespinRequestBuilder from "ags/integration/builders/requests/freespin-request-builder";
import spinRequestBuilder from "ags/integration/builders/requests/spin-request-builder";
import waysResultBuilder from "ags/integration/builders/results/ways-result-builder";
import AGSSocketConnector from "ags/integration/connector/ags-socket-connector";
import { AgsTransaction } from "ags/services/ags-transaction";
import Components from "slotworks/components/components";
import { PayoutMode } from "slotworks/components/paytable/paytable-component";
import PaytableComponent from "slotworks/components/paytable/paytable-component";
import canvasManager from "slotworks/graphics/canvas/canvas-manager";
import Loader from "slotworks/loader/loader";
import builderManager from "slotworks/server/builders/builder-manager";
import commsManager from "slotworks/server/comms-manager";
import { Services } from "slotworks/services/services";
import FreespinIdle from "slotworks/state-machine/standard/states/freespin-idle";
import DeviceInfo from "slotworks/utils/device-info";
import scatterResultBuilder from "./integration/builders/results/scatter-result-builder";
import lineResultBuilder from "ags/integration/builders/results/line-result-builder";

class AGS {

    public setupPowerExtremeGame() {

        canvasManager.iosScrollPromptEnabled = false;

        Services.onInit.addOnce(() => {
            if (DeviceInfo.isDesktop || (Services.sound.isMutePreferenceSet() && !Services.sound.getMuted())) {
                Loader.loadSoundsInPreloader = true;
            }
        });

        FreespinIdle.WAIT = 1000;
        FreespinIdle.WAIT_ONLY_WHEN_NO_WINS = true;

        commsManager.connector = AGSSocketConnector;
        builderManager.addRequestBuilder(authRequestBuilder);
        builderManager.addRequestBuilder(spinRequestBuilder);
        builderManager.addRequestBuilder(freespinRequestBuilder);

        builderManager.addRecordBuilder(authRecordBuilder);
        builderManager.addRecordBuilder(spinRecordBuilder);
        builderManager.addRecordBuilder(RecoveryRecordBuilder);

        builderManager.addResultBuilder(scatterResultBuilder);
        builderManager.addResultBuilder(waysResultBuilder);

        AGSControlList.init();

        PaytableComponent.payoutMode = PayoutMode.MULTIPLIER_ONLY;

        Components.BetBarComponentType = AGSBetBarComponent;

        Services.TransactionType = AgsTransaction;
    }

    public setupLinesGame() {

        canvasManager.iosScrollPromptEnabled = false;

        Services.onInit.addOnce(() => {
            if (DeviceInfo.isDesktop || (Services.sound.isMutePreferenceSet() && !Services.sound.getMuted())) {
                Loader.loadSoundsInPreloader = true;
            }
        });

        FreespinIdle.WAIT = 1000;
        FreespinIdle.WAIT_ONLY_WHEN_NO_WINS = true;

        commsManager.connector = AGSSocketConnector;
        builderManager.addRequestBuilder(authRequestBuilder);
        builderManager.addRequestBuilder(spinRequestBuilder);
        builderManager.addRequestBuilder(freespinRequestBuilder);

        builderManager.addRecordBuilder(authRecordBuilder);
        builderManager.addRecordBuilder(spinRecordBuilder);
        builderManager.addRecordBuilder(RecoveryRecordBuilder);

        builderManager.addResultBuilder(scatterResultBuilder);
        builderManager.addResultBuilder(lineResultBuilder);

        AGSControlList.init();

        PaytableComponent.payoutMode = PayoutMode.MULTIPLIER_ONLY;

        Components.BetBarComponentType = AGSBetBarComponent;

        Services.TransactionType = AgsTransaction;
    }

}

export default new AGS();
